import { makeStyles } from "@material-ui/core/styles";

export default makeStyles(() => ({
  wrapper: {
    padding: 0,
  },
}));
